/** @jsxImportSource @emotion/react */

import { Radio, RadioChangeEvent } from "antd";

import { PromotionCategoryStyle } from "./index.style";

const CATEGORIES = [
  {
    name: "HOT",
    value: "1",
  },
  {
    name: "Tất Cả",
    value: "2",
  },
  {
    name: "Nạp Tiền",
    value: "3",
  },
  {
    name: "Nổ Hũ",
    value: "4",
  },
  {
    name: "Bắn Cá",
    value: "5",
  },
  {
    name: "Sòng Bài",
    value: "6",
  },
  {
    name: "Game Bài",
    value: "7",
  },
  {
    name: "Thể Thao",
    value: "8",
  },
  {
    name: "Đá Gà",
    value: "9",
  },
];

interface PromotionCategoryProps {
  value: string;
  onValueChange?: (value: string) => void;
}

const PromotionCategory = (props: PromotionCategoryProps) => {
  const { value, onValueChange } = props;

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    onValueChange && onValueChange(value);
  };

  return (
    <div css={PromotionCategoryStyle.self}>
      <Radio.Group
        defaultValue="1"
        buttonStyle="solid"
        onChange={onChange}
        value={value}
      >
        {CATEGORIES.map((item) => (
          <Radio.Button key={item.value} value={item.value}>
            {item.name}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  );
};

export default PromotionCategory;
